import * as storage from 'client/javascript/storage';
import LeadForm from 'client/javascript/lead_form';
import getClosestMarket from 'client/javascript/get_closest_market';
import { Select } from '@wework/ray-core';
import { sendLeadFormHeapEvents } from 'client/javascript/form_analytics';
import { setupPhoneInput } from 'client/javascript/phone';
import { submitLead } from 'client/javascript/submit_lead';

const LEAD_SOURCE_DETAIL = 'Get a Quote Form';

async function populateLocationDropdown() {
  const closestMarket = (await getClosestMarket()) || {};
  const locationsDropdownSelect = Select.create(document.getElementById('locations-input-container'));
  const locationIdFromLocalStorage = storage.getLocationId();

  const locationId = locationIdFromLocalStorage || closestMarket.id;
  locationsDropdownSelect.set(locationId);
}

export async function setupQuoteForm(afterSubmit) {
  const phoneInput = document.getElementById('phone');
  setupPhoneInput(phoneInput);
  await populateLocationDropdown();

  const quoteForm = document.getElementById('quote-form');

  // eslint-disable-next-line no-new
  new LeadForm(quoteForm, async (_, values) => {
    const { email, locations: locationUuid, phone } = values;

    const leadData = {
      email,
      location_uuids: [locationUuid],
      marketing_consent: values.marketing_consent,
      phone,
      submission_type: 'lead'
    };

    await submitLead(leadData, LEAD_SOURCE_DETAIL);
    sendLeadFormHeapEvents(leadData, LEAD_SOURCE_DETAIL);

    afterSubmit();
  });
}
